import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';

@Component({
  selector: 'app-nt-forecast-time-progress',
  imports: [CommonModule],
  templateUrl: './nt-forecast-time-progress.component.html',
  styleUrl: './nt-forecast-time-progress.component.css'
})
export class NtForecastTimeProgressComponent {
  isLoading = false;
  today: Date = new Date();

  public medicineId: number = 0;
  public countryId: number = 1;

  allData: any[] = []; /*[
  {
    regionName: "Abruzzo",
    dueDate: "2025-11-13"
  },
  {
    regionName: "Basilicata",
    dueDate: "20260225"
  },
  {
    regionName: "Calabria",
    dueDate: "20250912"
  },
  {
    regionName: "Campania",
    dueDate: "20260130"
  },
  {
    regionName: "Emilia-Romagna",
    dueDate: "20251018"
  },
  {
    regionName: "Friuli-Venezia Giulia",
    dueDate: "20260210"
  },
  {
    regionName: "Lazio",
    dueDate: "20251122"
  },
  {
    regionName: "Liguria",
    dueDate: "20250828"
  },
  {
    regionName: "Lombardia",
    dueDate: "20260215"
  },
  {
    regionName: "Marche",
    dueDate: "20251203"
  },
  {
    regionName: "Molise",
    dueDate: "20250930"
  },
  {
    regionName: "Piemonte",
    dueDate: "20260105"
  },
  {
    regionName: "Puglia",
    dueDate: "20251105"
  },
  {
    regionName: "Sardegna",
    dueDate: "20250815"
  },
  {
    regionName: "Sicilia",
    dueDate: "20260228"
  },
  {
    regionName: "Toscana",
    dueDate: "20251220"
  },
  {
    regionName: "Trentino-Alto Adige",
    dueDate: "20251005"
  },
  {
    regionName: "Umbria",
    dueDate: "20260118"
  },
  {
    regionName: "Valle d'Aosta",
    dueDate: "20251130"
  },
  {
    regionName: "Veneto",
    dueDate: "20250908"
  }
];*/

  constructor (private dataService: DataService, private us: DmtUtilityService) { }

  ngOnInit (): void {
    this.isLoading = true;
    this.today.setHours(0, 0, 0, 0); // reset hours to compare only dates
    this.getSessionVariables();
    this.dataService.regionalAccessInfo(this.medicineId, this.countryId).subscribe(data => {
      this.allData = data;
      this.allData.sort((a, b) => a.regionName.localeCompare(b.regionName))
      this.isLoading = false;
    });
  }

  /** used to remove dash, dots or not numeric characters */
  private normalizeDateString (due: string): string {
    if (!due) return '';
    return due.replace(/[^0-9]/g, '');
  }


  formatDate (due: string): string {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 'No Data';

    const year = cleanDue.substring(0, 4);
    const month = cleanDue.substring(4, 6);
    const day = cleanDue.substring(6, 8);

    return `${day}/${month}/${year}`;
  }

  compareDates (due: string): number {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 0;

    const year = parseInt(cleanDue.substring(0, 4), 10);
    const month = parseInt(cleanDue.substring(4, 6), 10) - 1;
    const day = parseInt(cleanDue.substring(6, 8), 10);

    const dueDate = new Date(year, month, day);
    dueDate.setHours(0, 0, 0, 0);

    const delta = Math.round((this.today.getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24));
    return delta;
  }

  getSessionVariables () {
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
  }
}